// @ts-nocheck converted from existing component
// If making changes look to fix and remove this

import React from "react"

/*
This is the loader displayed when Appx is making the Main() call

It is the first call to the API and therefore we do not have any idea of what elements are to be loaded

So this is a generic layout based off the most likely dashboard layout
*/

function MainLayoutLoader() {
  return (
    <>
      <span className="sr-only">Loading</span>
      <div className="loader loader--nav"></div>
      <div className="loader loader--dashboard-intro"></div>
      <div className="layout-dashboard">
        {/* first column */}
        <div>
          <div className="loader loader--heading"></div>
          <div className="loader loader--large-1"></div>
          <div className="loader loader--large-1"></div>
        </div>
        {/* columns two and three */}
        <div className="layout-dashboard__main">
          <div className="layout-twocol">
            {/* column two */}
            <div className="layout-twocol__column">
              <div className="loader loader--heading"></div>
              <div className="loader loader--large"></div>
              <div className="loader loader--medium"></div>
              <div className="loader loader--fill-space"></div>
            </div>
            {/* column three */}
            <div className="layout-twocol__column">
              <div className="loader loader--heading"></div>
              <div className="loader loader--medium"></div>
              <div className="loader loader--large"></div>
              <div className="loader loader--fill-space"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default MainLayoutLoader
